import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import { api, saveAuth, errMsg } from "../lib/api";
import { GraduationCap, Eye, EyeSlash, ArrowLeft } from "@phosphor-icons/react";

export default function Login() {
  const nav = useNavigate();
  const [identifier, setIdentifier] = useState("");
  const [pwd, setPwd] = useState("");
  const [showPwd, setShowPwd] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { identifier, password: pwd });
      saveAuth(data.token, data.profile, data.role);
      toast.success(data.role === "parent" ? "Veli paneline hoş geldin!" : "Hoş geldin!");
      nav(data.role === "parent" ? "/parent" : "/app");
    } catch (err) {
      toast.error(errMsg(err));
    } finally { setLoading(false); }
  };

  return (
    <div className="app-shell w-full max-w-md mx-auto min-h-[100dvh] px-6 py-10 flex flex-col">
      <Link to="/" data-testid="login-back-home" className="mb-4 inline-flex items-center gap-2 text-brand-ink2 font-nunito font-semibold text-sm">
        <ArrowLeft size={18} /> Ana sayfa
      </Link>
      <div className="flex items-center gap-3 mb-8">
        <div className="w-12 h-12 rounded-2xl bg-brand-primary flex items-center justify-center">
          <GraduationCap size={28} weight="duotone" color="#1D3557" />
        </div>
        <div>
          <div className="font-outfit font-extrabold text-2xl text-brand-ink leading-none">Ödevix</div>
          <div className="font-nunito text-sm text-brand-ink2 mt-1">Veli e-postan veya öğrenci kullanıcı adınla giriş yap.</div>
        </div>
      </div>

      <h1 className="font-outfit font-extrabold text-3xl sm:text-4xl tracking-tight leading-tight text-brand-ink mb-2">
        Tekrar hoş geldin 👋
      </h1>

      <form onSubmit={submit} className="flex flex-col gap-4 mt-4">
        <div>
          <label className="font-nunito text-sm font-semibold text-brand-ink2 block mb-1.5">E-posta veya kullanıcı adı</label>
          <input
            data-testid="login-identifier-input" required
            value={identifier} onChange={(e) => setIdentifier(e.target.value)}
            className="w-full bg-white border border-black/10 rounded-2xl px-4 py-3.5 font-nunito text-brand-ink focus:outline-none focus:ring-2 focus:ring-brand-primary"
            placeholder="anne@mail.com veya ela_ogrenci"
          />
        </div>
        <div>
          <label className="font-nunito text-sm font-semibold text-brand-ink2 block mb-1.5">Şifre</label>
          <div className="relative">
            <input
              data-testid="login-password-input" type={showPwd ? "text" : "password"}
              required minLength={6}
              value={pwd} onChange={(e) => setPwd(e.target.value)}
              className="w-full bg-white border border-black/10 rounded-2xl px-4 py-3.5 pr-12 font-nunito text-brand-ink focus:outline-none focus:ring-2 focus:ring-brand-primary"
            />
            <button type="button" onClick={() => setShowPwd(!showPwd)} className="absolute right-3 top-1/2 -translate-y-1/2 p-2 text-brand-ink2">
              {showPwd ? <EyeSlash size={20} /> : <Eye size={20} />}
            </button>
          </div>
        </div>
        <button
          data-testid="login-submit-button" type="submit" disabled={loading}
          className="mt-4 w-full bg-brand-primary text-brand-ink font-outfit font-bold text-lg py-4 rounded-full shadow-[0_4px_18px_rgba(255,183,3,0.45)] disabled:opacity-50"
        >{loading ? "Bekleniyor..." : "Giriş Yap"}</button>
      </form>

      <Link to="/register" data-testid="login-go-register" className="mt-6 font-nunito text-brand-ink2 text-sm">
        Hesabın yok mu? <span className="font-bold text-brand-ink underline underline-offset-4">Kayıt ol</span>
      </Link>
      <Link to="/forgot-password" data-testid="forgot-password-link" className="mt-2 font-nunito text-sm text-brand-ink2 underline underline-offset-4">
        Veli şifremi unuttum
      </Link>
    </div>
  );
}
